/* Size guide: centimetre view for range cells ("34-35" -> "86.4-88.9"). theme.js converts single
   numbers only; this runs after it on the same click and fixes range cells. */
(() => {
  const sg = document.getElementById('sg');
  if (!sg) return;
  const cm = v => (Math.round(parseFloat(v) * 2.54 * 10) / 10).toString();
  sg.addEventListener('click', e => {
    const b = e.target.closest('[data-u]'); if (!b) return;
    sg.querySelectorAll('td[data-in]').forEach(td => {
      const m = td.dataset.in.match(/^\s*([\d.]+)\s*[-–]\s*([\d.]+)\s*$/);
      if (m) td.textContent = b.dataset.u === 'cm' ? `${cm(m[1])}–${cm(m[2])}` : td.dataset.in;
    });
  });
})();

/* Product gallery follows the chosen colour: only that colour's photos show, and the photo viewer
   steps through those photos only. Photos carry data-color from main-product.liquid. */
(() => {
  const gal = document.querySelector('.gallery[data-color-index]');
  const form = document.querySelector('[data-product-form]');
  if (!gal || !form) return;
  const ci = +gal.dataset.colorIndex;
  if (ci < 0) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const btns = [...gal.querySelectorAll('[data-shot]')];
  if (!btns.some(b => b.dataset.color)) return;
  const sets = [...form.querySelectorAll('fieldset.opt')];
  const dots = document.querySelector('.gdots');
  // v1-0-13: the photos on show, in display order. A colour with fewer than MIN photos of its own
  // shows its photos first, then every other photo of the product, so the gallery is never one picture.
  const MIN = 3;
  let list = btns.slice();
  const vis = () => list;
  let shown = null;
  // v1-0-14: up to 5 photos show dots; more show a "1 / 22" counter
  const mark = i => {
    const n = vis().length;
    dots.innerHTML = n > 5 ? `<span class="gcount">${i + 1} / ${n}</span>` : Array.from({ length: n }, (_, k) => `<i class="${k === i ? 'on' : ''}"></i>`).join('');
  };

  const apply = first => {
    const fs = sets[ci], c = fs && fs.querySelector('input:checked');
    if (!c || c.value === shown || !btns.some(b => b.dataset.color === c.value)) return;
    shown = c.value;
    const own = btns.filter(b => b.dataset.color === c.value);
    list = own.length >= MIN ? own : own.concat(btns.filter(b => b.dataset.color !== c.value));
    btns.forEach(b => { const k = list.indexOf(b); b.hidden = k < 0; b.style.order = k < 0 ? '' : k; b.classList.remove('g-lead', 'g-more'); });
    list.forEach((b, i) => {
      if (i === 0) b.classList.add('g-lead');
      if (i > 4) b.classList.add('g-more');
      const im = b.querySelector('img'); if (im && i < 3) im.loading = 'eager';
    });
    gal.setAttribute('data-filtered', '');
    if (dots) mark(0);
    if (!first) {
      if (!reduce) gal.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 260, easing: 'cubic-bezier(0.23,1,0.32,1)' });
      gal.scrollTo({ left: 0 });
      if (gal.getBoundingClientRect().top < 0) gal.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  };
  form.addEventListener('change', () => apply(false));
  apply(true);

  // phone dots: index among the visible photos
  if (dots && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting && e.intersectionRatio > .6) { const i = vis().indexOf(e.target); if (i > -1) mark(i); }
    }), { root: gal, threshold: [.6] });
    btns.forEach(b => io.observe(b));
  }

  // photo viewer: step through this colour only
  const lbox = document.querySelector('.lbox'), frame = document.querySelector('[data-lframe]');
  if (!lbox || !frame) return;
  let cur = null;
  gal.addEventListener('click', e => { const b = e.target.closest('[data-shot]'); if (b) cur = b; }, true);
  const step = d => {
    const list = vis(); if (!list.length) return;
    let i = list.indexOf(cur); i = ((i < 0 ? 0 : i) + d + list.length) % list.length; cur = list[i];
    let im = frame.querySelector('img'); if (!im) { im = document.createElement('img'); frame.appendChild(im); }
    im.src = cur.dataset.full; const src = cur.querySelector('img'); im.alt = src ? src.alt : ''; frame.classList.remove('z');
  };
  const nav = (sel, d) => { const el = lbox.querySelector(sel); if (el) el.addEventListener('click', e => { if (!shown) return; e.stopImmediatePropagation(); step(d); }, true); };
  nav('[data-ln]', 1); nav('[data-lp]', -1);
  document.addEventListener('keydown', e => {
    if (!shown || !lbox.classList.contains('on')) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.stopImmediatePropagation(); step(e.key === 'ArrowRight' ? 1 : -1); }
  }, true);
})();
